<template>
  <mtd-col>
    <!-- 顶部按钮栏 -->
    <mtd-row>
      <mtd-col :span="12" class="height-full">
        <span class="page-title-32">{{ $getText('wenshu_menu_disk_mount_apply', '文枢空间挂载申请') }}</span>
      </mtd-col>
      <mtd-col :span="12" class="height-full text-right">
        <mtd-button type="primary" @click="open_create_modal" style="margin-right: 0;">{{ $getText('wenshu_web_application', '申请') }}</mtd-button>
      </mtd-col>
    </mtd-row>
    <!-- 表格 -->
    <mtd-row style="margin-top:12px;">
      <mtd-col :span="24">
        <mtd-table size="small" :data="apply_list" :tooltip-props="{ size: 'small' }" :empty-text="$getText('wenshu_web_no_data', '暂无数据')">
          <mtd-table-column prop="misId" :label="$getText('wenshu_web_applicant', '申请人')" width="200" show-overflow-tooltip/>
          <mtd-table-column prop="applyMisId" :label="$getText('wenshu_web_application_mount_account', '申请挂载账号')" width="230" show-overflow-tooltip/>
          <mtd-table-column prop="applyReason" :label="$getText('wenshu_web_application_reason', '申请原因')" show-overflow-tooltip/>
          <mtd-table-column prop="createTime" :label="$getText('wenshu_web_application_time', '申请时间')" width="150" show-overflow-tooltip/>
          <mtd-table-column prop="bpmStatus" :label="$getText('wenshu_web_approval_status', '审批状态')" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.bpmStatus === 0">
                <i class='mtdicon mtdicon-time-o' style="font-size:14px;color: #0a70f5"/>
                {{ $getText('wenshu_web_under_approval', '审批中') }}
              </span>
              <span v-if="scope.row.bpmStatus === 1">
                <i class='mtdicon mtdicon-success-o' style="font-size:14px;color: #00b365"/>
                {{ $getText('wenshu_web_approved', '已通过') }}
              </span>
              <span v-if="scope.row.bpmStatus === 2">
                <i class='mtdicon mtdicon-error-o' style="font-size:14px;color: #f5483b"/>
                {{ $getText('wenshu_web_rejected', '已拒绝') }}
              </span>
              <span v-if="scope.row.bpmStatus === 6">
                <i class='mtdicon mtdicon-warning-circle-o' style="font-size:14px;color: #ffc300"/>
                {{ $getText('wenshu_web_closed', '已关闭') }}
              </span>
            </template>
          </mtd-table-column>
          <mtd-table-column :label="$getText('wenshu_web_operation', '操作')" width="160">
            <template slot-scope="scope">
              <a :href="scope.row.bpmDetailUrl" target="_blank" :disabled="!scope.row.bpmDetailUrl">
                <mtd-button type="text" size="small" class="operate-btns" style="padding: 0; color: #0a70f5"
                            :disabled="!scope.row.bpmDetailUrl">
                  {{ $getText('wenshu_web_view_approval_flow', '查看审批流') }}
                </mtd-button>
              </a>
            </template>
          </mtd-table-column>
        </mtd-table>
      </mtd-col>
    </mtd-row>
    <!-- 添加申请Modal -->
    <mtd-modal :title="$getText('wenshu_web_other_account_mount_application', '其他账号文枢空间挂载申请')" width="640px" v-model="create_apply_modal" @close="close_create_modal">
      <mtd-form :label-width="124" ref="user_apply_form" :rules="rule_custom" :model="form_data">
        <mtd-form-item :label="$getText('wenshu_web_applicant', '申请人') + ':'">
          <mtd-input type="text" style="width: 100%;" v-model="this.login_user.name" :disabled="true"/>
        </mtd-form-item>
        <mtd-form-item :label="$getText('wenshu_web_application_mount_account', '申请挂载账号') + ':'" prop="applyMisId">
          <mtd-select v-model="form_data.applyMisId" :placeholder="$getText('wenshu_web_enter_mis_to_search', '请输入MIS号查找')" :filterable="true"
                      :remote="true" style="width: 100%" :remote-method="searchPerson" :debounce="500"
                      key="targetMis_list_select" :clearable="true">
            <mtd-option v-for="item in person_groups" :key="item.mis" :label="item.mis" :value="item.mis"/>
          </mtd-select>
        </mtd-form-item>
        <mtd-form-item :label="$getText('wenshu_web_application_reason', '申请原因') + ':'" prop="applyReason">
          <mtd-textarea :placeholder="$getText('wenshu_web_enter_application_reason', '请输入申请原因')" v-model="form_data.applyReason" style="width: 100%;" rows="5"/>
        </mtd-form-item>
        <p>{{ $getText('wenshu_web_note_approval_required_before_migration', '注：申请后需上级审批，审批通过后才可进行数据迁移操作') }}</p>
      </mtd-form>
      <div slot="footer" class="demo-modal-footer" style="padding-top: 12px;">
        <mtd-button @click="close_create_modal">{{ $getText('wenshu_web_cancel', '取消') }}</mtd-button>
        <mtd-button type="primary" @click="submit_create_modal" :disabled="create_modal_valid || submit_btn_disabled">
          {{ $getText('wenshu_web_confirm', '确定') }}
        </mtd-button>
      </div>
    </mtd-modal>
  </mtd-col>
</template>

<script>

import {mapActions} from "vuex";
import moment from "moment";
import {BPM_STATUS} from "@/constants/bpm_file"

export default {
  name: "other_trace_view_apply",
  filters: {
    dateTimeFormat(dateTime) {
      return moment(dateTime)
        .utcOffset(480)
        .format('YYYY-MM-DD HH:mm:ss');
    },
    // 为审批状态转换中文
    BpmStatusFilter(status) {
      return BPM_STATUS[status]
    },
  },
  data() {
    return {
      apply_list: [],
      create_apply_modal: false,
      form_data: {
        applyMisId: null,
        applyReason: null,
      },
      person_groups: [],
      submit_btn_disabled: false,
      rule_custom: {
        applyMisId: [
          {required: true, message: this.$getText('wenshu_web_enter_mount_account', '请输入挂载账号')},
          {
            validator: (_rule, value, callback) => {
              console.log(arguments)
              if (!value || value === '') {
                return callback(new Error(this.$getText('wenshu_web_enter_mount_account', '请输入挂载账号')))
              }
              console.log(this.login_user);
              if (value === this.login_user.mis) {
                return callback(new Error(this.$getText('wenshu_web_mount_account_cannot_be_same_as_applicant', '挂载账号不能和当前申请人相同')))
              }
              return callback()
            }, trigger: 'blur'
          },
        ],
        applyReason: [
          {required: true, message: this.$getText('wenshu_web_enter_application_reason', '请输入申请原因')}
        ]
      }
    }
  },
  computed: {
    login_user() {
      return this.$store.getters.get_login_user;
    },
    create_modal_valid() {
      if (!this.form_data.applyMisId || this.form_data.applyMisId === '') {
        return true;
      }
      if (!this.form_data.applyReason || this.form_data.applyReason === '') {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.list_table_data();
  },
  methods: {
    ...mapActions({
      'api_list_apply': 'api_cryptbox_device_data_migration_user_list',
      'api_submit_apply': 'api_cryptbox_device_data_migration_save',
      'query_mis_id_list': 'api_cryptbox_device_query_mis_id',
    }),

    list_table_data() {
      this.api_list_apply(this.search_form).then((res) => {
        let data = res.data;
        this.apply_list = data.items;
      });
    },
    open_create_modal() {
      this.create_apply_modal = true;
    },
    close_create_modal() {
      this.create_apply_modal = false;
      this.form_data = {
        applyMisId: null,
        applyReason: null,
      };
      this.person_groups = [];
      this.submit_btn_disabled = false;
      let user_apply_form = this.$refs['user_apply_form']
      user_apply_form.clearValidate()
    },
    submit_create_modal() {
      this.submit_btn_disabled = true;
      this.api_submit_apply(this.form_data).then(() => {
        this.$mtd.message.success(this.$getText('wenshu_web_application_submitted_successfully', '申请提交成功！'));
        this.close_create_modal();
        this.list_table_data();
      });
    },
    // 搜索mis
    searchPerson(keyword) {
      if (keyword != null && keyword !== "") {
        this.query_mis_id_list({keyword}).then(res => {
          this.person_groups = res.data
        }).catch((err) => {
          console.log(err)
        })
      }
    },
  }
}
</script>

<style scoped>
 .test-clear{
   clear: both;
 }
</style>
